import PrimaryPalette from '../colors';

export const IconTheme = {
  default: {
    color: PrimaryPalette.mediumEvergreen,
  },
};
